"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.denormalize = exports.parse = void 0;
const menu_1 = require("./core/menu");
/**
 * Denormalizes a set of links into an instance of a Menu.
 * {@inheritDoc Menu.from}
 * {@see {@link NormalizedMenuInterface}}
 */
function denormalize(normalized, menuID) {
    return menu_1.Menu.from(normalized, menuID);
}
exports.denormalize = denormalize;
/**
 * Parses Drupal menu JSON into a Menu instance.
 * {@see {@link denormalize}}
 */
function parse(json, menuID) {
    return denormalize(JSON.parse(json), menuID);
}
exports.parse = parse;
